var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotionNormalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44ZM24 40C28.2435 40 32.3131 38.3143 35.3137 35.3137C38.3143 32.3131 40 28.2435 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8C19.7565 8 15.6869 9.68571 12.6863 12.6863C9.68571 15.6869 8 19.7565 8 24C8 28.2435 9.68571 32.3131 12.6863 35.3137C15.6869 38.3143 19.7565 40 24 40ZM16 28H32V32H16V28ZM16 22C15.2044 22 14.4413 21.6839 13.8787 21.1213C13.3161 20.5587 13 19.7956 13 19C13 18.2044 13.3161 17.4413 13.8787 16.8787C14.4413 16.3161 15.2044 16 16 16C16.7956 16 17.5587 16.3161 18.1213 16.8787C18.6839 17.4413 19 18.2044 19 19C19 19.7956 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7956 22 16 22ZM32 22C31.2044 22 30.4413 21.6839 29.8787 21.1213C29.3161 20.5587 29 19.7956 29 19C29 18.2044 29.3161 17.4413 29.8787 16.8787C30.4413 16.3161 31.2044 16 32 16C32.7956 16 33.5587 16.3161 34.1213 16.8787C34.6839 17.4413 35 18.2044 35 19C35 19.7956 34.6839 20.5587 34.1213 21.1213C33.5587 21.6839 32.7956 22 32 22Z",
    fill: "#FFD100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionNormalLine);
export default __webpack_public_path__ + "static/media/emotion-normal-line.b72bb03a89e74310e46a3bed5f49fc33.svg";
export { ForwardRef as ReactComponent };